import { render, staticRenderFns } from "./icon-warning.vue?vue&type=template&id=17d1cc9e&scoped=true&"
var script = {}
import style0 from "./icon-warning.vue?vue&type=style&index=0&id=17d1cc9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d1cc9e",
  null
  
)

export default component.exports